module.exports = __webpack_public_path__ + "img/product_52.c75a336.webp";